module.exports = __webpack_public_path__ + "assets/SMS.png";


//////////////////
// WEBPACK FOOTER
// ./images/SMS.png
// module id = 299
// module chunks = 0